import Auth from "@/store/auth";
import store from "@/store/auth";

class ComparisonMainGroups {
    getList() {
        return new Promise((resolve) => {
            let url = process.env.VUE_APP_API + "comparison_main_groups/";

            fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + Auth.getters.getJwt
                }
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(json => {
                        resolve(json);
                    });
                } else if (response.status === 401) {
                    Auth.dispatch("setJwt", "");
                    resolve(false);
                }
            });
        });
    }

    getListWithSubGroups() {
        return new Promise((resolve) => {
            let url = process.env.VUE_APP_API + "comparison_main_groups/subgroups/";

            fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + Auth.getters.getJwt
                }
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(json => {
                        resolve(json);
                    });
                } else if (response.status === 401) {
                    Auth.dispatch("setJwt", "");
                    resolve(false);
                }
            });
        });
    }

    add(name) {
        return new Promise(resolve => {
            let url =
                process.env.VUE_APP_API + "comparison_main_groups/";

            let data = {
                "name": name
            }

            fetch(url, {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: {
                    'Authorization': 'Bearer ' + store.getters.getJwt
                }
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(json => {
                        resolve(json.result)
                    });
                } else if (response.status === 401) {
                    Auth.dispatch("setJwt", "");
                }
            });
        });
    }

    update(mainGroupId, name) {
        return new Promise((resolve) => {
            let url = process.env.VUE_APP_API + "comparison_main_groups/" + mainGroupId + "/";

            let data = {
                "name": name
            }

            fetch(url, {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: {
                    'Authorization': 'Bearer ' + store.getters.getJwt
                }
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(json => {
                        resolve(json.result)
                    });
                } else if (response.status === 401) {
                    Auth.dispatch("setJwt", "");
                    resolve(false)
                }
            });
        });
    }

    remove(mainGroupId) {
        return new Promise(resolve => {
            let url =
                process.env.VUE_APP_API + "comparison_main_groups/" + mainGroupId + "/";

            fetch(url, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + store.getters.getJwt
                }
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(json => {
                        resolve(json.result)
                    });
                } else if (response.status === 401) {
                    Auth.dispatch("setJwt", "");
                }
            });
        });
    }
}

export default new ComparisonMainGroups();

